import { z } from 'zod';

export const AccountAccessModeSchema = z.enum(['personal', 'shared_tablet']);
export type AccountAccessMode = z.infer<typeof AccountAccessModeSchema>;

export const ActiveTenantAccountContextSchema = z.object({
  tenant_id: z.string().uuid(),
  user_id: z.string().uuid(),
  role: z.enum(['consulente', 'ristoratore', 'osa', 'staff']),
  access_mode: AccountAccessModeSchema,
  visibility_subject: z.string().min(1).max(100),
}).superRefine((value, ctx) => {
  const expected = value.access_mode === 'shared_tablet'
    ? `account:${value.user_id}`
    : value.role;
  if (value.visibility_subject !== expected) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['visibility_subject'],
      message: 'Soggetto visibilita non coerente con la modalita account',
    });
  }
  if (value.access_mode === 'shared_tablet' && value.role !== 'staff') {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['role'],
      message: 'Un tablet condiviso deve mantenere il ruolo staff',
    });
  }
});

export type ActiveTenantAccountContext = z.infer<typeof ActiveTenantAccountContextSchema>;

export function shouldShowSharedTabletGate(input: {
  hasSession: boolean;
  isSharedTablet: boolean;
  resolved: boolean;
  hasActiveOperator: boolean;
}): boolean {
  return input.hasSession
    && input.isSharedTablet
    && (!input.resolved || !input.hasActiveOperator);
}

export function accountVisibilitySubject(
  role: ActiveTenantAccountContext['role'],
  userId: string,
  accessMode: AccountAccessMode,
): string {
  return accessMode === 'shared_tablet' ? `account:${userId}` : role;
}
